import { render, staticRenderFns } from "./officialList.vue?vue&type=template&id=18b83ba2&scoped=true"
import script from "./officialList.vue?vue&type=script&lang=js"
export * from "./officialList.vue?vue&type=script&lang=js"
import style0 from "./officialList.vue?vue&type=style&index=0&id=18b83ba2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b83ba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b83ba2')) {
      api.createRecord('18b83ba2', component.options)
    } else {
      api.reload('18b83ba2', component.options)
    }
    module.hot.accept("./officialList.vue?vue&type=template&id=18b83ba2&scoped=true", function () {
      api.rerender('18b83ba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/official/officialList/officialList.vue"
export default component.exports